import { SelectChangeEvent } from '@mui/material';
import React from 'react';

import { FormErrorMessage } from '@/shared/components/ui/form/components/form-error-message/form-error-message';
import { FormLabel } from '@/shared/components/ui/form/components/form-label/form-label';
import { MenuPaper } from '@/shared/components/ui/paper/menu-paper/menu-paper';
import {
  CustomFormControl,
  PositionedClearButton,
  CustomSelect,
} from '@/shared/components/ui/styled-select/styled-select.styled';
import { TSelectProps } from '@/shared/components/ui/styled-select/styled-select.types';

export const StyledSelect: React.FC<TSelectProps> = ({
  size,
  error,
  name,
  label,
  required,
  ...props
}) => {
  const { onChange } = props;
  const showClearButton = false;

  const clearEvent = {
    target: { value: undefined, name: name || '' },
    currentTarget: { value: undefined, name: name || '' },
    bubbles: false,
    cancelBubble: false,
    cancelable: false,
    composed: false,
  } as unknown as SelectChangeEvent<null>;

  const handleClear = () => {
    if (!onChange) {
      return;
    }
    onChange(clearEvent, null);
  };

  return (
    <CustomFormControl fullWidth error={!!error}>
      {label && (
        <FormLabel id={`${name}-label`} label={label} required={required} />
      )}
      <CustomSelect
        {...props}
        labelId={`${name}-label`}
        variant="outlined"
        $size={size}
        MenuProps={{
          PaperProps: {
            component: MenuPaper,
            style: {
              maxHeight: '300px',
            },
          },
        }}
      />
      {error && <FormErrorMessage field={label} />}
      {showClearButton && (
        <PositionedClearButton $hasLabel={!!label} onClick={handleClear} />
      )}
    </CustomFormControl>
  );
};
